/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';

import {ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';
import {convertCollaborationsToCollaborators} from 'auth/PermissionConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {UpdateOwnableParams} from 'create-components/OwnableConstants';
import {OwnableSettingsWithCollaborationsModal} from 'create-components/OwnableSettingsModal';
import {writeFragmentsToCache} from 'graphql-client/ApolloWrappers';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {CreateTemplateParams} from 'notebook/entry-templates/collections/TemplateCollectionDAO';
import TemplateCollectionDAO from 'notebook/entry-templates/collections/TemplateCollectionDAO';
import notifications from 'notifications';

interface Props {
  onRequestClose: (...args: Array<any>) => any;
}

class CreateTemplateCollectionModal extends React.Component<Props> {
  createCollection({
    name,
    description,
    owner,
    collaborators,
    ownerInfo,
  }: CreateTemplateParams): JQueryPromise<any> {
    return TemplateCollectionDAO.create({name, description, owner, collaborators, ownerInfo})
      .always(() => {
        $('#fileLoading').addClass('hidden');
      })
      .done((templateCollectionResponse) => {
        writeFragmentsToCache(getFragmentWrapper('TemplateCollectionSummary'), [
          {
            __typename: 'TemplateCollectionNode',
            ...templateCollectionResponse,
          },
        ]);
      })
      .fail(notifications.notifyError);
  }

  override render(): JSX.Element {
    return (
      <OwnableSettingsWithCollaborationsModal
        onRequestClose={this.props.onRequestClose}
        ownableType={ModelTypeConstants.TEMPLATE_COLLECTION}
        doSubmit={(data: UpdateOwnableParams) =>
          this.createCollection({
            ...data,
            collaborators:
              data.collaborations &&
              convertCollaborationsToCollaborators(data.collaborations.filter((c) => !c.fromOwnership)),
          })
        }
        analyticsModule={ANALYTICS_MODULE.ELN}
        analyticsModalType="create_template_collection"
      />
    );
  }
}

export default CreateTemplateCollectionModal;
